import { ref, computed, watch } from 'vue'
import { formationArgumentaireService } from '../../services/index.js'

/**
 * Composable pour gérer les argumentaires commerciaux dans QuoteDetail
 */
export function useQuoteDetailArgumentaire(formationNomRef) {
  const loading = ref(false)
  const formationArgumentaires = ref([])
  const generalArgumentaires = ref([])

  const hasNoArgumentaires = computed(() => {
    return !loading.value &&
           formationArgumentaires.value.length === 0 &&
           generalArgumentaires.value.length === 0
  })

  const hasArgumentaires = computed(() => {
    return formationArgumentaires.value.length > 0 ||
           generalArgumentaires.value.length > 0
  })

  const loadArgumentaires = async () => {
    const formationNom = formationNomRef.value

    if (!formationNom) {
      formationArgumentaires.value = []
      generalArgumentaires.value = []
      return
    }

    loading.value = true
    try {
      const result = await formationArgumentaireService.getForQuote(formationNom)
      formationArgumentaires.value = result.formation || []
      generalArgumentaires.value = result.general || []
    } catch (error) {
      console.error('Error loading argumentaires:', error)
      formationArgumentaires.value = []
      generalArgumentaires.value = []
    } finally {
      loading.value = false
    }
  }

  // Charger les argumentaires quand la formation change
  watch(
    () => formationNomRef.value,
    () => {
      loadArgumentaires()
    },
    { immediate: true }
  )

  return {
    loading,
    formationArgumentaires,
    generalArgumentaires,
    hasNoArgumentaires,
    hasArgumentaires,
    loadArgumentaires
  }
}
